import type { List as FullList, RetailItem } from 'apis/list/graphqlTypes';

export default (languageCode: string) => /* GraphQL */ `
fragment ListFields on List {
  updated
  quantity
  name
  isSelected
  listId
  retail(languageCode: "${languageCode}") {
    items {
      itemNo
      quantity
      product {
        globalName
      }
    }
  }
}`;

// This type represents the object above
export type List = Pick<FullList, 'updated' | 'quantity' | 'name' | 'isSelected' | 'listId'> & {
    retail?: {
        items: Pick<RetailItem, 'itemNo' | 'quantity'>[];
    };
};
